import { render, staticRenderFns } from "./AvanzarNivelPage.vue?vue&type=template&id=7bbeb772&scoped=true&"
import script from "./AvanzarNivelPage.vue?vue&type=script&lang=js&"
export * from "./AvanzarNivelPage.vue?vue&type=script&lang=js&"
import style0 from "./AvanzarNivelPage.vue?vue&type=style&index=0&id=7bbeb772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbeb772",
  null
  
)

export default component.exports